/* eslint-disable no-unsafe-optional-chaining */
import React, { useState } from 'react';
import { Button, Card, Col, Form, Modal } from 'react-bootstrap';
// import JobDetailsGmap from './JobDetailsGmap';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import moment from 'moment';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import Avatar from 'components/common/Avatar';
import IconButton from 'components/common/IconButton';
import {
  getNurseAvaJobDate,
  getNurseUniqueIdDetails,
  getSwapNurseAvailableList
} from 'nursd-dashboard/api/nurseTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { socket } from 'nursd-dashboard/api/socket';
import { updateJobTable } from 'nursd-dashboard/api/jobTable';
import { postFacilityNotification } from 'nursd-dashboard/api/facilityNotification';
import {
  getAllFacilityList,
  getFacilityDetails
} from 'nursd-dashboard/api/facilityTable';
import { useAppContext } from 'providers/AppProvider';
import { useEffect } from 'react';
import { DateFormat, jobUniqueId } from 'nursd-dashboard/utils/function';
import UserJobCard from './UserJobCard';
import { getAcceptJobDetail } from 'nursd-dashboard/api/nurseDashboard';

const JobDetailContent = ({
  job,
  // nurses,
  getJobDetail
}) => {
  const {
    config: { isDark }
  } = useAppContext();

  function GetDateMergedTime(date, time) {
    const date1 = moment(date).format('YYYY-MM-DD');
    const time1 = moment(time).format('hh:mm a');
    const mergedTime = moment(`${date1} ${time1}`, `YYYY-MM-DD hh:mm a`);
    return mergedTime;
  }

  const { authToken, organization, location } = useAuth();
  const [docViewModel, setDocViewModel] = useState({
    view: false,
    name: '',
    url: ''
  });
  const [loading, setLoading] = useState(false);
  const [nurseSwap, setNurseSwap] = useState(false);
  const [nurseSwapReason, setNurseSwapReason] = useState('');
  const [searchSwapNurse, setSearchSwapNurse] = useState('');
  const [swapOldNurse, setSwapOldNurse] = useState(undefined);
  const [jobFinalSelectionNurseId, setJobFinalSelectionNurseId] = useState('');
  const [availableLoading, setAvailableLoading] = useState(true);
  const [available, setAvailable] = useState([]);
  const [removeNurseReason, setRemoveNurseReason] = useState('');
  const [removeNurse, setRemoveNurse] = useState(false);
  const [removeNurseObj, setRemoveNurseObj] = useState([]);
  const [removeNurseBid, setRemoveNurseBid] = useState(false);
  const [removeNurseBidObj, setRemoveNurseBidObj] = useState([]);

  const webCancel = item => {
    setRemoveNurseObj({
      id: item?.id,
      uniqueId: item?.uniqueId,
      mobileId: item?.mobileId,
      type: item?.nurseType,
      name: item?.firstName + ' ' + item?.lastName
    });
    setRemoveNurse(true);
  };

  const webCancelBid = item => {
    setRemoveNurseBid(true);
    setRemoveNurseBidObj({
      id: item?.id,
      uniqueId: item?.uniqueId,
      mobileId: item?.mobileId,
      type: item?.nurseType,
      amount: '',
      name: item?.firstName + ' ' + item?.lastName
    });
  };

  // const getNurseDetail = async id => {
  //   if (id == null) {
  //     return [];
  //   } else {
  //     try {
  //       const nurseData = await getNurseUniqueIdDetails(authToken, id);
  //       return nurseData[0];
  //     } catch (error) {
  //       console.log('data save error:', error);
  //       return [];
  //     }
  //   }
  // };

  const getJobFinalSelectionNurseIdDetails = async () => {
    const nurseData = await getNurseUniqueIdDetails(
      authToken,
      job?.jobFinalSelectionNurseId
    );

    setSwapOldNurse({
      mobileId: nurseData[0]?.mobileId,
      id: nurseData[0]?.id
    });
  };

  // const getNursesMobileIds = async data => {
  //   const nursePromises = data
  //     ?.filter(id => id != null)
  //     .map(id => getNurseDetail(id));
  //   const nursesData = await Promise.all(nursePromises);
  //   return nursesData;
  // };

  useEffect(() => {
    if (job !== undefined) {
      if (nurseSwap) {
        const get = async () => {
          setAvailableLoading(true);
          await getSwapNurseAvailableList(
            authToken,
            organization,
            location,
            job.startDate,
            job.endDate,
            moment(new Date(job?.startTime)).format('hh:mm a'),
            moment(new Date(job?.endTime)).format('hh:mm a'),
            job?.licenseType,
            job?.fullAddress
          )
            .then(res => {
              setAvailable(res);
              setAvailableLoading(false);
            })
            .catch(e => console.log(e));
        };
        get();
      }
    }
  }, [job, nurseSwap]);

  useEffect(() => {
    if (job !== undefined) {
      if (job?.jobFinalSelectionNurseId) {
        getJobFinalSelectionNurseIdDetails();
      }
    }
  }, [job]);

  const filterSwapNurse = data => {
    return data?.filter(item =>
      item?.id?.name?.toLowerCase().includes(searchSwapNurse?.toLowerCase())
    );
  };

  const swapNurse = async () => {
    setLoading(true);
    if (jobFinalSelectionNurseId === '') {
      alert('To process the swap select the nurse');
      setLoading(false);
    } else if (nurseSwapReason === '') {
      alert('Fill the reason.');
      setLoading(false);
    } else {
      try {
        let date = `${moment(job?.startTime).format('hh:mm a')}-${moment(
          job?.endTime
        ).format('hh:mm a')}`;

        const nurseJobFinalSelectionNurseId = available.filter(item => {
          return item?.id?.uniqueId === jobFinalSelectionNurseId;
        });

        await updateJobTable(authToken, job?.id, {
          jobAcceptedNurses: [jobFinalSelectionNurseId],
          jobFinalSelectionNurseId: jobFinalSelectionNurseId?.toString(),
          nurseSwapNotes: nurseSwapReason,
          jobCompletedBy: nurseJobFinalSelectionNurseId[0]?.id?.nurseType,
          jobRequestedNurses: [
            {
              id: jobFinalSelectionNurseId?.toString(),
              type: nurseJobFinalSelectionNurseId[0]?.id?.nurseType
            }
          ]
        }).catch(e => console.log(e));

        socket?.emit('tableJobInsert', {
          table: 'JobPostingTable',
          message: 'Fetch Dashboard Job'
        });

        await postNurseNotification(
          authToken,
          swapOldNurse?.id,
          '',
          `"${job?.jobType} Swap Request Processed"`,
          `${job?.jobType} for ${DateFormat(job?.startDate)}  ${date}`,
          'JobDetailsScreen',
          {
            id: job?.id
          },
          false,
          false,
          'green',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'NurseNotificationTable',
          id: swapOldNurse?.id
        });
        if (swapOldNurse?.mobileId) {
          sendNotification(authToken, {
            expoPushToken: swapOldNurse?.mobileId,
            title: `"${job?.jobType} Swap Request Processed"`,
            body: `${job?.jobType} for ${DateFormat(job?.startDate)}  ${date}`,
            data: { jobId: job?.id, screen: 'JobDetailScreen' }
          });
        }

        if (nurseJobFinalSelectionNurseId[0]?.id?.mobileId) {
          sendNotification(authToken, {
            expoPushToken: nurseJobFinalSelectionNurseId[0]?.id?.mobileId,
            title: `“Direct Swap ${job?.jobType} Assignment” (Check Upcoming Jobs)`,
            body: `${job?.jobType} for ${DateFormat(job?.startDate)}  ${date}`,
            data: { jobId: job?.id, screen: 'JobDetailScreen' }
          });
        }

        await postNurseNotification(
          authToken,
          nurseJobFinalSelectionNurseId[0]?.id?.id,
          '',
          `“Direct Swap ${job?.jobType} Assignment” (Check Upcoming Jobs)`,
          `${job?.jobType} for ${DateFormat(job?.startDate)}  ${date}`,
          'JobDetailsScreen',
          {
            id: job?.id
          },
          false,
          false,
          'green',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'NurseNotificationTable',
          id: nurseJobFinalSelectionNurseId[0]?.id?.id
        });

        setNurseSwap(false);
        setNurseSwapReason('');
        setJobFinalSelectionNurseId('');
        setAvailable([]);
        setLoading(false);
        alert('Swapped Successfully.');
        getJobDetail(job?.id);
      } catch (error) {
        console.log('data save error:', error);
      }
    }
  };

  // const removeValue = (array, value) => {
  //   const filteredArray = array?.filter(item => item !== value);
  //   return filteredArray.length !== array.length ? filteredArray : array;
  // };

  const removeDeclinedValue = (array, value) => {
    const filteredArray = array?.filter(item => item?.id !== value);
    return filteredArray.length !== array.length
      ? filteredArray?.map(i => ({
          id: i?.id,
          type: i?.type
        }))
      : array?.map(i => ({
          id: i?.id,
          type: i?.type
        }));
  };

  const removeBidValue = (array, value) => {
    const filteredArray = array?.filter(
      item => item?.jobBitTableNurseTableId !== value
    );
    return filteredArray.length !== array.length ? filteredArray : array;
  };

  const getFacilityDetail = async id => {
    // console.log(id);
    try {
      const facilityData = await getFacilityDetails(authToken, id);
      return facilityData;
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  const getFacilityLocationDetail = async id => {
    try {
      const facilityData = await getAllFacilityList(authToken, id, 'facility');
      return facilityData;
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  //Normal job approved function
  const selectNurse = async (id, uniqueId, type, mobileId) => {
    if (type === 'Agency') {
      await updateJobTable(authToken, job?.id, {
        jobFinalSelectionNurseId: uniqueId?.toString(),
        jobAcceptedNurses: [uniqueId?.toString()],
        approved_manager: job?.jobPostingTableFacilityTableId,
        jobStatus: 'Nurse Assigned',
        jobCompletedBy: job?.jobSharedType,
        jobCompletedAgencyId: Number(job?.jobSharedId)
      }).catch(e => console.log(e));
      getJobDetail(job?.id);
    } else {
      const res = await getNurseAvaJobDate(
        authToken,
        id,
        uniqueId,
        job?.startDate,
        job?.endDate,
        moment(new Date(job?.startTime)).format('hh:mm a'),
        moment(new Date(job?.endTime)).format('hh:mm a')
      );

      if (res?.availableTime) {
        try {
          job?.jobRequestedNurses?.forEach(async nurseData => {
            const nurseDataUniqueId = nurseData?.uniqueId;
            const nurseDataId = nurseData?.id;
            const nurseDataMobileId = nurseData?.mobileId;
            const nurseType = nurseData?.nurseType;
            if (nurseDataUniqueId !== uniqueId) {
              if (nurseType === 'Internal Pool') {
                await postNurseNotification(
                  authToken,
                  nurseDataId,
                  '',
                  jobUniqueId(job?.id, job?.jobType),
                  'Your Request Expired for this job',
                  'JobDetailsScreen',
                  {
                    id: job?.id
                  },
                  false,
                  false,
                  'red',
                  ''
                );
                if (nurseDataMobileId) {
                  sendNotification(authToken, {
                    expoPushToken: nurseDataMobileId,
                    title: job?.shiftTitle,
                    body: `Your Request Expired for job ${jobUniqueId(
                      job?.id,
                      job?.jobType
                    )}`,
                    data: { jobId: job?.id, screen: 'JobDetailScreen' }
                  });
                }
                socket?.emit('tableNotificationInsert', {
                  table: 'NurseNotificationTable',
                  id: nurseDataId
                });
              }
            }
          });

          await updateJobTable(authToken, job?.id, {
            jobFinalSelectionNurseId: uniqueId?.toString(),
            jobAcceptedNurses: [uniqueId?.toString()],
            approved_manager: job?.jobPostingTableFacilityTableId,
            jobCompletedBy: type,
            jobStatus: 'Nurse Assigned'
          }).catch(e => console.log(e));
          socket?.emit('tableJobInsert', {
            table: 'JobPostingTable',
            message: 'Fetch Dashboard Job'
          });
          await postNurseNotification(
            authToken,
            id,
            '',
            jobUniqueId(job?.id, job?.jobType),
            `You got approved for this job`,
            'JobDetailsScreen',
            {
              id: job?.id
            },
            false,
            false,
            'green',
            ''
          );
          if (mobileId) {
            sendNotification(authToken, {
              expoPushToken: mobileId,
              title: job?.shiftTitle,
              body: `Approved for job ${jobUniqueId(job?.id, job?.jobType)}`,
              data: { jobId: job?.id, screen: 'JobDetailScreen' }
            });
          }
          socket?.emit('tableNotificationInsert', {
            table: 'NurseNotificationTable',
            id: id
          });
          if (
            parseInt(job?.jobPostingTableFacilityTableId) !==
            parseInt(job?.jobPostingTableFacilityTableId)
          ) {
            const facilityDetail = await getFacilityDetail(
              job?.jobPostingTableFacilityTableId
            );
            await postFacilityNotification(
              authToken,
              job?.jobPostingTableFacilityTableId,
              '',
              jobUniqueId(job?.id, job?.jobType),
              `Your job Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
              'JobDetailsScreen',
              {
                id: job?.id
              },
              false,
              false,
              'green',
              ''
            );
            socket?.emit('tableNotificationInsert', {
              table: 'FacilityNotificationTable',
              id: job?.jobPostingTableFacilityTableId
            });
            if (job?.manager?.mobileId) {
              sendNotification(authToken, {
                expoPushToken: job?.manager?.mobileId,
                title: jobUniqueId(job?.id, job?.jobType),
                body: `Your job Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                data: { jobId: job?.id, screen: 'JobDetailScreen' }
              });
            }
          }
          getJobDetail(job?.id);
        } catch (error) {
          console.log('data save error:', error);
        }
      } else {
        alert(`Date Conflict. Choose a different date.`);
      }
    }
  };

  const cancelNurse = async () => {
    setLoading(true);
    try {
      if (removeNurseObj?.type === 'Agency') {
        await updateJobTable(authToken, job?.id, {
          jobFinalSelectionNurseId: '',
          jobRequestedNurses: [],
          jobAcceptedNurses: [],
          approved_manager: '',
          jobStatus: 'Open',
          jobCompletedAgencyId: 0,
          jobCompletedBy: '',
          jobSharedAction: 'Rejected',
          nurseCancelNotes: !Array.isArray(job?.nurseCancelNotes)
            ? [
                {
                  nurseId: removeNurseObj?.id,
                  nurseName: removeNurseObj?.name,
                  cancelNote: removeNurseReason
                }
              ]
            : [
                ...job?.nurseCancelNotes,
                {
                  nurseId: removeNurseObj?.id,
                  nurseName: removeNurseObj?.name,
                  cancelNote: removeNurseReason
                }
              ]
        }).catch(e => console.log(e));
      } else {
        await updateJobTable(authToken, job?.id, {
          jobFinalSelectionNurseId: '',
          jobRequestedNurses: [],
          jobAcceptedNurses: [],
          approved_manager: '',
          jobStatus: 'Open',
          jobCompletedBy: '',
          nurseCancelNotes: !Array.isArray(job?.nurseCancelNotes)
            ? [
                {
                  nurseId: removeNurseObj?.id,
                  nurseName: removeNurseObj?.name,
                  cancelNote: removeNurseReason
                }
              ]
            : [
                ...job?.nurseCancelNotes,
                {
                  nurseId: removeNurseObj?.id,
                  nurseName: removeNurseObj?.name,
                  cancelNote: removeNurseReason
                }
              ]
        }).catch(e => console.log(e));
      }
      socket?.emit('tableJobInsert', {
        table: 'JobPostingTable',
        message: 'Fetch Dashboard Job'
      });

      await postNurseNotification(
        authToken,
        Number(removeNurseObj?.id),
        '',
        jobUniqueId(job?.id, job?.jobType),
        'You have been released from the assignment. For any questions, please reach out to Manager',
        'JobDetailsScreen',
        {
          id: job?.id
        },
        false,
        false,
        'red',
        ''
      );
      if (removeNurseObj?.mobileId) {
        sendNotification(authToken, {
          expoPushToken: removeNurseObj?.mobileId,
          title: jobUniqueId(job?.id, job?.jobType) + ' ' + job?.shiftTitle,
          body: 'You have been released from the assignment. For any questions, please reach out to Manager',
          data: { jobId: job?.id, screen: 'JobDetailScreen' }
        });
      }
      socket?.emit('tableNotificationInsert', {
        table: 'NurseNotificationTable',
        id: removeNurseObj?.id
      });
      //If other manager approved sending notification to job origin manager
      if (
        parseInt(job?.jobPostingTableFacilityTableId) !==
        parseInt(job?.jobPostingTableFacilityTableId)
      ) {
        const facilityDetail = await getFacilityDetail(
          job?.jobPostingTableFacilityTableId
        );
        await postFacilityNotification(
          authToken,
          job?.jobPostingTableFacilityTableId,
          '',
          jobUniqueId(job?.id, job?.jobType),
          `This ${facilityDetail?.firstName} ${facilityDetail?.lastName} manager removed the nurse.`,
          'JobDetailsScreen',
          {
            id: job?.id
          },
          false,
          false,
          'red',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'FacilityNotificationTable',
          id: job?.jobPostingTableFacilityTableId
        });

        if (job?.manager?.mobileId) {
          sendNotification(authToken, {
            expoPushToken: job?.manager?.mobileId,
            title: jobUniqueId(job?.id, job?.jobType),
            body: `This ${facilityDetail?.firstName} ${facilityDetail?.lastName} manager removed the nurse.`,
            data: { jobId: job?.id, screen: 'JobDetailScreen' }
          });
        }
      }
      setRemoveNurse(false);
      setRemoveNurseReason('');
      setRemoveNurseObj(undefined);
      setLoading(false);
      getJobDetail(job?.id);
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  const selectNurseBid = async (id, uniqueId, type, mobileId, amount) => {
    if (type === 'Agency') {
      await updateJobTable(authToken, job?.id, {
        jobFinalSelectionNurseId: uniqueId?.toString(),
        jobAcceptedNurses: [uniqueId?.toString()],
        approved_manager: job?.jobPostingTableFacilityTableId,
        jobStatus: 'Nurse Assigned',
        jobCompletedBy: job?.jobSharedType,
        jobCompletedAgencyId: Number(job?.jobSharedId)
      }).catch(e => console.log(e));
      getJobDetail(job?.id);
    } else {
      try {
        const res = await getNurseAvaJobDate(
          authToken,
          id,
          uniqueId,
          job?.startDate,
          job?.endDate,
          moment(new Date(job?.startTime)).format('hh:mm a'),
          moment(new Date(job?.endTime)).format('hh:mm a')
        );
        if (res?.availableTime) {
          await updateJobTable(authToken, job?.id, {
            jobFinalSelectionNurseId: uniqueId?.toString(),
            jobAcceptedNurses: [uniqueId?.toString()],
            approved_manager: job?.jobPostingTableFacilityTableId,
            jobCompletedBy: type,
            jobBitFinalAmount: amount,
            jobStatus: 'Nurse Assigned'
          }).catch(e => console.log(e));
          socket?.emit('tableJobInsert', {
            table: 'JobPostingTable',
            message: 'Fetch Dashboard Job'
          });
          await postNurseNotification(
            authToken,
            id,
            '',
            jobUniqueId(job?.id, job?.jobType),
            'Your Bid-Approved for this job',
            'JobDetailsScreen',
            {
              id: job?.id
            },
            false,
            false,
            'green',
            ''
          );
          socket?.emit('tableNotificationInsert', {
            table: 'NurseNotificationTable',
            id: id
          });
          if (mobileId) {
            sendNotification(authToken, {
              expoPushToken: mobileId,
              title: job?.shiftTitle,
              body: `Your Bid-Approved for this job ${jobUniqueId(
                job?.id,
                job?.jobType
              )}`,
              data: { jobId: job?.id, screen: 'JobDetailScreen' }
            });
          }
          job?.jobRequestedNurses?.forEach(async nurseData => {
            const nurseDataUniqueId = nurseData?.uniqueId;
            const nurseDataId = nurseData?.id;
            const nurseDataMobileId = nurseData?.mobileId;
            const nurseType = nurseData?.nurseType;
            if (nurseDataUniqueId !== uniqueId) {
              if (nurseType === 'Internal Pool') {
                await postNurseNotification(
                  authToken,
                  nurseDataId,
                  '',
                  jobUniqueId(job?.id, job?.jobType),
                  'Your Bid-Expired for this job',
                  'JobDetailsScreen',
                  {
                    id: job?.id
                  },
                  false,
                  false,
                  'red',
                  ''
                );
                socket?.emit('tableNotificationInsert', {
                  table: 'NurseNotificationTable',
                  id: nurseDataId
                });
                if (!nurseDataMobileId) {
                  return;
                }
                sendNotification(authToken, {
                  expoPushToken: nurseDataMobileId,
                  title: job?.shiftTitle,
                  body: `Your Bid-Expired for job ${jobUniqueId(
                    job?.id,
                    job?.jobType
                  )}`,
                  data: { jobId: job?.id, screen: 'JobDetailScreen' }
                });
              }
            }
          });
          if (
            parseInt(job?.jobPostingTableFacilityTableId) !==
            parseInt(job?.jobPostingTableFacilityTableId)
          ) {
            const facilityDetail = await getFacilityDetail(
              job?.jobPostingTableFacilityTableId
            );
            await postFacilityNotification(
              authToken,
              job?.jobPostingTableFacilityTableId,
              '',
              jobUniqueId(job?.id, job?.jobType),
              `Your Bid-Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
              'JobDetailsScreen',
              {
                id: job?.id
              },
              false,
              false,
              'green',
              ''
            );
            socket?.emit('tableNotificationInsert', {
              table: 'FacilityNotificationTable',
              id: job?.id
            });
            if (job?.manager?.mobileId) {
              sendNotification(authToken, {
                expoPushToken: job?.manager?.mobileId,
                title: jobUniqueId(job?.id, job?.jobType),
                body: `Your Bid-Approved by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                data: { jobId: job?.id, screen: 'JobDetailScreen' }
              });
            }
          }
          getJobDetail(job?.id);
        } else {
          alert(`Date Conflict. Choose a different date.`);
        }
      } catch (error) {
        console.log('data save error:', error);
      }
    }
  };

  const cancelNurseBid = async () => {
    setLoading(true);
    try {
      await updateJobTable(authToken, job?.id, {
        jobFinalSelectionNurseId: '',
        jobRequestedNurses: [],
        jobAcceptedNurses: [],
        approved_manager: '',
        jobStatus: 'Open',
        jobCompletedBy: '',
        jobBitFinalAmount: removeNurseBidObj?.amount,
        nurseCancelNotes: !Array.isArray(job?.nurseCancelNotes)
          ? [
              {
                nurseId: removeNurseBidObj?.id,
                nurseName: removeNurseBidObj?.name,
                cancelNote: removeNurseReason
              }
            ]
          : [
              ...job?.nurseCancelNotes,
              {
                nurseId: removeNurseBidObj?.id,
                nurseName: removeNurseBidObj?.name,
                cancelNote: removeNurseReason
              }
            ],
        bidNurseArray: removeBidValue(job?.bidNurseArray, removeNurseBidObj?.id)
      }).catch(e => console.log(e));
      // if (removeNurseBidObj?.type === 'Internal Pool') {
      socket?.emit('tableJobInsert', {
        table: 'JobPostingTable',
        message: 'Fetch Dashboard Job'
      });
      await postNurseNotification(
        authToken,
        Number(removeNurseBidObj?.id),
        '',
        jobUniqueId(job?.id, job?.jobType),
        'You have been released from the assignment. For any questions, please reach out to Manager',
        'JobDetailsScreen',
        {
          id: job?.id
        },
        false,
        false,
        'red',
        ''
      );
      socket?.emit('tableNotificationInsert', {
        table: 'NurseNotificationTable',
        id: removeNurseBidObj?.id
      });
      if (removeNurseBidObj?.mobileId) {
        sendNotification(authToken, {
          expoPushToken: removeNurseBidObj?.mobileId,
          title: jobUniqueId(job?.id, job?.jobType) + ' ' + job?.shiftTitle,
          body: 'You have been released from the assignment. For any questions, please reach out to Manager',
          data: { jobId: job?.id, screen: 'JobDetailScreen' }
        });
      }
      // }
      if (
        parseInt(job?.jobPostingTableFacilityTableId) !==
        parseInt(job?.jobPostingTableFacilityTableId)
      ) {
        const facilityDetail = await getFacilityDetail(
          job?.jobPostingTableFacilityTableId
        );
        await postFacilityNotification(
          authToken,
          job?.jobPostingTableFacilityTableId,
          '',
          jobUniqueId(job?.id, job?.jobType),
          `This ${facilityDetail?.firstName} ${facilityDetail?.lastName} manager removed the nurse.`,
          'JobDetailsScreen',
          {
            id: job?.id
          },
          false,
          false,
          'red',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'FacilityNotificationTable',
          id: job?.jobPostingTableFacilityTableId
        });

        if (job?.manager?.mobileId) {
          sendNotification(authToken, {
            expoPushToken: job?.manager?.mobileId,
            title: jobUniqueId(job?.id, job?.jobType),
            body: `This ${facilityDetail?.firstName} ${facilityDetail?.lastName} manager removed the nurse.`,
            data: { jobId: job?.id, screen: 'JobDetailScreen' }
          });
        }
      }
      setRemoveNurseBid(false);
      setRemoveNurseReason('');
      setRemoveNurseBidObj(undefined);
      setLoading(false);
      getJobDetail(job?.id);
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  const declinedNurseAction = async (id, uniqueId, mobileId, type, name) => {
    let jobDetails = await getAcceptJobDetail(authToken, job?.id);

    let ava = jobDetails[0]?.bidNurseArray?.find(
      item => item?.jobBitTableNurseTableId === id
    );
    if (ava === undefined) {
      try {
        if (type === 'Agency') {
          await updateJobTable(authToken, jobDetails[0]?.id, {
            jobFinalSelectionNurseId: '',
            jobRequestedNurses: removeDeclinedValue(
              jobDetails[0]?.jobRequestedNurses,
              uniqueId
            ),
            jobStatus:
              jobDetails[0]?.jobRequestedNurses?.length <= 1
                ? 'Open'
                : 'Pending Assignment',
            jobCompletedBy: '',
            jobSharedAction: 'Rejected'
          }).catch(e => console.log(e));
        } else {
          await updateJobTable(authToken, jobDetails[0]?.id, {
            jobFinalSelectionNurseId: '',
            jobRequestedNurses: removeDeclinedValue(
              jobDetails[0]?.jobRequestedNurses,
              uniqueId
            ),
            jobStatus:
              jobDetails[0]?.jobRequestedNurses?.length <= 1
                ? 'Open'
                : 'Pending Assignment'
          }).catch(e => console.log(e));
        }
        socket?.emit('tableJobInsert', {
          table: 'JobPostingTable',
          message: 'Fetch Dashboard Job'
        });
        await postNurseNotification(
          authToken,
          id,
          '',
          jobUniqueId(jobDetails[0]?.id, jobDetails[0]?.jobType),
          'This job request has been denied. For further queries, please reach out to Manager',
          'JobDetailsScreen',
          {
            id: jobDetails[0]?.id
          },
          false,
          false,
          'red',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'NurseNotificationTable',
          id: id
        });
        if (mobileId) {
          sendNotification(authToken, {
            expoPushToken: mobileId,
            title:
              jobUniqueId(jobDetails[0]?.id, jobDetails[0]?.jobType) +
              ' ' +
              jobDetails[0]?.shiftTitle,
            body: 'This job request has been denied. For further queries, please reach out to Manager',
            data: { jobId: jobDetails[0]?.id, screen: 'JobDetailScreen' }
          });
        }
        //Sending notification to other manager
        getFacilityLocationDetail(jobDetails[0]?.jobPostingTableFacilityTableId)
          .then(async facilitiesData => {
            for (const facility of facilitiesData) {
              if (
                parseInt(jobDetails[0]?.jobPostingTableFacilityTableId) !==
                parseInt(facility?.id)
              ) {
                try {
                  const facilityDetail = await getFacilityDetail(
                    jobDetails[0]?.jobPostingTableFacilityTableId
                  );
                  await postFacilityNotification(
                    authToken,
                    facility?.id,
                    '',
                    jobUniqueId(jobDetails[0]?.id, jobDetails[0]?.jobType),
                    `This job has been cancelled to ${name}-${type} by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                    'JobDetailsScreen',
                    {
                      id: jobDetails[0]?.id
                    },
                    false,
                    false,
                    'red',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'FacilityNotificationTable',
                    id: facility?.id
                  });
                  if (facility?.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: facility?.mobileId,
                      title: jobUniqueId(
                        jobDetails[0]?.id,
                        jobDetails[0]?.jobType
                      ),
                      body: `This job has been cancelled to ${name} by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                      data: {
                        jobId: jobDetails[0]?.id,
                        screen: 'JobDetailScreen'
                      }
                    });
                  }
                } catch (error) {
                  console.error('Error fetching facility detail:', error);
                }
              }
            }
          })
          .catch(error => console.error(error));
        getJobDetail(jobDetails[0]?.id);
      } catch (error) {
        console.log('data save error:', error);
      }
    }
    //Bid Nurse Cancel
    else {
      try {
        await updateJobTable(authToken, jobDetails[0]?.id, {
          jobFinalSelectionNurseId: '',
          jobRequestedNurses: removeDeclinedValue(
            jobDetails[0]?.jobRequestedNurses,
            uniqueId
          ),
          jobStatus:
            jobDetails[0]?.jobRequestedNurses?.length <= 1
              ? 'Open'
              : 'Pending Assignment',
          bidNurseArray: removeBidValue(jobDetails[0]?.bidNurseArray, id)
        }).catch(e => console.log(e));
        socket?.emit('tableJobInsert', {
          table: 'JobPostingTable',
          message: 'Fetch Dashboard Job'
        });
        await postNurseNotification(
          authToken,
          id,
          '',
          jobUniqueId(jobDetails[0]?.id, jobDetails[0]?.jobType),
          'This job request has been denied. For further queries, please reach out to Manager',
          'JobDetailsScreen',
          {
            id: jobDetails[0]?.id
          },
          false,
          false,
          'red',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'NurseNotificationTable',
          id: id
        });
        if (mobileId) {
          sendNotification(authToken, {
            expoPushToken: mobileId,
            title:
              jobUniqueId(jobDetails[0]?.id, jobDetails[0]?.jobType) +
              ' ' +
              jobDetails[0]?.shiftTitle,
            body: 'This job request has been denied. For further queries, please reach out to Manager',
            data: { jobId: jobDetails[0]?.id, screen: 'JobDetailScreen' }
          });
        }
        //Sending notification to other manager
        getFacilityLocationDetail(jobDetails[0]?.jobPostingTableFacilityTableId)
          .then(async facilitiesData => {
            for (const facility of facilitiesData) {
              if (
                parseInt(jobDetails[0]?.jobPostingTableFacilityTableId) !==
                parseInt(facility?.id)
              ) {
                try {
                  const facilityDetail = await getFacilityDetail(
                    jobDetails[0]?.jobPostingTableFacilityTableId
                  );
                  await postFacilityNotification(
                    authToken,
                    facility?.id,
                    '',
                    jobUniqueId(jobDetails[0]?.id, jobDetails[0]?.jobType),
                    `This job has been cancelled to ${name} by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                    'JobDetailsScreen',
                    {
                      id: jobDetails[0]?.id
                    },
                    false,
                    false,
                    'red',
                    ''
                  );
                  socket?.emit('tableNotificationInsert', {
                    table: 'FacilityNotificationTable',
                    id: facility?.id
                  });
                  if (facility?.mobileId) {
                    sendNotification(authToken, {
                      expoPushToken: facility?.mobileId,
                      title: jobUniqueId(
                        jobDetails[0]?.id,
                        jobDetails[0]?.jobType
                      ),
                      body: `This job has been cancelled to ${name} by ${facilityDetail?.firstName} ${facilityDetail?.lastName}.`,
                      data: {
                        jobId: jobDetails[0]?.id,
                        screen: 'JobDetailScreen'
                      }
                    });
                  }
                } catch (error) {
                  console.error('Error fetching facility detail:', error);
                }
              }
            }
          })
          .catch(error => console.error(error));
      } catch (error) {
        console.log('data save error:', error);
      }
    }
  };

  return (
    <Card>
      <Card.Body>
        {job?.jobFinalSelectionNurseId === '' ? (
          job?.jobStatus !== 'Unfulfilled' && (
            <div>
              <Flex justifyContent={'between'} className="mb-2">
                {job?.jobRequestedNurses && (
                  <h5 className="fs-9 mb-3">
                    Requested Nurse List {job?.enableBid && '- With Bid Rate'}
                  </h5>
                )}
                {!job?.enableBid &&
                  job?.checkInTime === '' &&
                  job?.jobFinalSelectionNurseId !== '' &&
                  job?.jobStatus === 'Nurse Assigned' && (
                    <IconButton
                      variant="primary"
                      className="me-2"
                      size="sm"
                      onClick={() => {
                        setNurseSwap(true);
                      }}
                    >
                      Swap
                    </IconButton>
                  )}
              </Flex>
              {job?.jobRequestedNurses
                ?.filter(i => i?.uniqueId !== job?.jobFinalSelectionNurseId)
                .flat()
                .map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor:
                          job?.jobFinalSelectionNurseId === item?.uniqueId
                            ? '#e6ffee'
                            : '#fff',
                        borderRadius: 5,
                        padding: 10
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        <div>
                          {item?.profileImage ? (
                            <Avatar
                              src={item?.profileImage}
                              size="3xl"
                              className="me-2"
                            />
                          ) : (
                            <Avatar
                              size="3xl"
                              name={item?.firstName + ' ' + item?.lastName}
                              className="me-2"
                            />
                          )}
                        </div>

                        <div
                          style={{
                            marginLeft: 5,
                            flex: 1
                          }}
                        >
                          <div
                            style={{
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'space-between'
                            }}
                          >
                            <p style={{ fontSize: 16, fontWeight: '600' }}>
                              {item?.firstName} {item?.lastName}{' '}
                              <span className="text-primary">
                                (
                                {item?.nurseType === 'Internal Pool'
                                  ? 'Internal Staff'
                                  : item?.nurseType === 'Float Pool'
                                  ? 'Float'
                                  : item?.nurseType}
                                )
                              </span>
                            </p>
                            {job?.jobFinalSelectionNurseId ===
                              item?.uniqueId && (
                              <div
                                style={{
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  marginLeft: 10
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: 12,
                                    fontWeight: '600',
                                    color: '#00b359'
                                  }}
                                >
                                  Selected
                                </p>
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                          >
                            <p
                              style={{
                                fontSize: 14,
                                fontWeight: '400'
                              }}
                            >
                              {item?.primaryLicenseType}
                            </p>

                            {job?.bidNurseArray
                              ?.filter(
                                value =>
                                  value?.jobBitTableNurseTableId ===
                                  item?.uniqueId
                              )
                              .map((item, index) => (
                                <p
                                  key={index}
                                  style={{
                                    fontSize: 12,
                                    fontWeight: '600',
                                    color: '#000'
                                  }}
                                >
                                  Bid:{' '}
                                  <p
                                    key={item?.uniqueId}
                                    style={{
                                      fontSize: 12,
                                      fontWeight: '600',
                                      color: '#ff3333'
                                    }}
                                  >
                                    ${item?.bitAmount}
                                  </p>
                                </p>
                              ))}
                            {/* {acceptedJobs?.map((value) =>
                              value?.jobBitTableNurseTableId === item?.uniqueId ? (
                                <p
                                  key={item?.uniqueId}
                                  style={{
                                    fontSize: 15,
                                    fontWeight: "600",
                                    color: "#ff3333",
                                  }}
                                >
                                  $ {value?.bitAmount} 
                                </p>
                              ) : null
                            )} */}
                            {job?.enableBid &&
                            job?.bidNurseArray?.filter(
                              value =>
                                value?.jobBitTableNurseTableId ===
                                item?.uniqueId
                            )?.length === 0 ? (
                              <p
                                style={{
                                  fontSize: 15,
                                  fontWeight: '600',
                                  color: '#00b359'
                                }}
                              >
                                $ {job?.baseRate}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div>
                        {item?.nurseType !== 'Agency' && (
                          <Link to={paths.nursd_profile(item?.id, 'profile')}>
                            <IconButton
                              icon=""
                              variant="primary"
                              className="me-2"
                              size="sm"
                            >
                              View Profile
                            </IconButton>
                          </Link>
                        )}
                        {/* <Button
                        style={{
                          backgroundColor: '#ddd',
                          paddingHorizontal: 10,
                          paddingVertical: 5,
                          borderRadius: 8,
                          marginRight: 10
                        }}
                        onClick={() =>
                          onChatRoomNavigate({
                            chatRoomId: undefined,
                            nurseId: item?.uniqueId,
                            facilityId: userUniqueId
                          })
                        }
                      >
                        <p
                          style={{
                            fontSize: 12,
                            fontWeight: '600',
                            color: '#000'
                          }}
                        >
                          Message
                        </p>
                      </Button> */}
                        {job?.checkInTime === '' &&
                          (job?.jobFinalSelectionNurseId === '' ||
                            job?.jobFinalSelectionNurseId === item?.uniqueId) &&
                          // moment(job?.startDate).format("MM-DD-YYYY") >= currentDate &&
                          GetDateMergedTime(
                            job?.startDate,
                            job?.startTime
                          ).isSameOrAfter(moment(), 'hh:mm a') && (
                            <IconButton
                              variant={
                                job?.jobFinalSelectionNurseId === item?.uniqueId
                                  ? 'danger'
                                  : 'success'
                              }
                              size="sm"
                              className="me-2"
                              onClick={() =>
                                job?.bidNurseArray?.length === 0
                                  ? job?.jobFinalSelectionNurseId ===
                                    item?.uniqueId
                                    ? confirm(
                                        'To Release the assigned nurse. Click OK'
                                      ).valueOf(true) && webCancel(item)
                                    : !item?.nurseAppAccessControl
                                    ? selectNurse(
                                        item?.id,
                                        item?.uniqueId,
                                        item?.nurseType,
                                        item?.mobileId
                                      )
                                    : alert(
                                        `${item?.firstName} ${item?.lastName} account is currently Suspended.`
                                      )
                                  : job?.bidNurseArray
                                      ?.filter(
                                        v =>
                                          v?.jobBitTableNurseTableId ===
                                          item?.uniqueId
                                      )
                                      .map(
                                        value =>
                                          value?.jobBitTableNurseTableId ===
                                            item?.uniqueId &&
                                          (job?.jobFinalSelectionNurseId ===
                                          item?.uniqueId
                                            ? confirm(
                                                'Are you sure want to cancel?'
                                              ).valueOf(true) &&
                                              webCancelBid(item)
                                            : selectNurseBid(
                                                item?.uniqueId,
                                                item?.mobileId,
                                                value?.bitAmount
                                              ))
                                      )
                              }
                            >
                              {job?.jobFinalSelectionNurseId === item?.uniqueId
                                ? 'Release'
                                : 'Approve'}
                            </IconButton>
                          )}
                        {job?.jobFinalSelectionNurseId !== item?.uniqueId &&
                          job?.jobStatus !== 'Unfulfilled' && (
                            <IconButton
                              variant="danger"
                              size="sm"
                              className="me-2"
                              onClick={() => {
                                let name =
                                  item?.firstName + ' ' + item?.lastName;
                                confirm('Are you sure want to Deny?').valueOf(
                                  true
                                ) &&
                                  declinedNurseAction(
                                    item?.id,
                                    item?.uniqueId,
                                    item?.mobileId,
                                    item?.nurseType,
                                    name
                                  );
                              }}
                            >
                              Deny
                            </IconButton>
                          )}
                      </div>
                    </div>
                  );
                })}
            </div>
          )
        ) : (
          <div>
            <Flex justifyContent={'between'} className="mb-2">
              <h5 className="fs-9 mb-3">Nurse</h5>
              {!job?.enableBid &&
                job?.checkInTime === '' &&
                job?.jobStatus === 'Nurse Assigned' && (
                  <IconButton
                    variant="primary"
                    className="me-2"
                    size="sm"
                    onClick={() => {
                      setNurseSwap(true);
                    }}
                  >
                    Swap
                  </IconButton>
                )}
            </Flex>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#e6ffee',
                borderRadius: 5,
                padding: 10
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <div>
                  {job?.nurse?.profileImage ? (
                    <Avatar
                      src={job?.nurse?.profileImage}
                      size="3xl"
                      className="me-2"
                    />
                  ) : (
                    <Avatar
                      size="3xl"
                      name={job?.nurse?.firstName + ' ' + job?.nurse?.lastName}
                      className="me-2"
                    />
                  )}
                </div>

                <div
                  style={{
                    marginLeft: 5,
                    flex: 1
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <p style={{ fontSize: 16, fontWeight: '600' }}>
                      {job?.nurse?.firstName} {job?.nurse?.lastName}{' '}
                      <span className="text-primary">
                        (
                        {job?.nurse?.nurseType === 'Internal Pool'
                          ? 'Internal Staff'
                          : job?.nurse?.nurseType === 'Float Pool'
                          ? 'Float'
                          : job?.nurse?.nurseType}
                        )
                      </span>
                    </p>
                    <div
                      style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginLeft: 10
                      }}
                    >
                      <p
                        style={{
                          fontSize: 12,
                          fontWeight: '600',
                          color: '#00b359'
                        }}
                      >
                        Selected
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}
                  >
                    <p
                      style={{
                        fontSize: 14,
                        fontWeight: '400'
                      }}
                    >
                      {job?.nurse?.primaryLicenseType}
                    </p>

                    {job?.bidNurseArray
                      ?.filter(
                        value =>
                          value?.jobBitTableNurseTableId ===
                          job?.nurse?.uniqueId
                      )
                      .map((item, index) => (
                        <p
                          key={index}
                          style={{
                            fontSize: 12,
                            fontWeight: '600',
                            color: '#000'
                          }}
                        >
                          Bid:{' '}
                          <p
                            key={item}
                            style={{
                              fontSize: 12,
                              fontWeight: '600',
                              color: '#ff3333'
                            }}
                          >
                            ${item?.bitAmount}
                          </p>
                        </p>
                      ))}
                    {job?.enableBid &&
                    job?.bidNurseArray?.filter(
                      value =>
                        value?.jobBitTableNurseTableId === job?.nurse?.uniqueId
                    )?.length === 0 ? (
                      <p
                        style={{
                          fontSize: 15,
                          fontWeight: '600',
                          color: '#00b359'
                        }}
                      >
                        $ {job?.baseRate}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>

              <div>
                {job?.nurse?.nurseType !== 'Agency' && (
                  <Link to={paths.nursd_profile(job?.nurse?.id, 'profile')}>
                    <IconButton
                      icon=""
                      variant="primary"
                      className="me-2"
                      size="sm"
                    >
                      View Profile
                    </IconButton>
                  </Link>
                )}
                {/*
                 <Button
                    style={{
                      backgroundColor: '#ddd',
                      paddingHorizontal: 10,
                      paddingVertical: 5,
                      borderRadius: 8,
                      marginRight: 10
                    }}
                    onClick={() =>
                      onChatRoomNavigate({
                        chatRoomId: undefined,
                        nurseId: item?.uniqueId,
                        facilityId: userUniqueId
                      })
                    }
                  >
                    <p
                      style={{
                        fontSize: 12,
                        fontWeight: '600',
                        color: '#000'
                      }}
                    >
                      Message
                    </p>
                  </Button> 
                  */}
                {job?.checkInTime === '' &&
                  (job?.jobFinalSelectionNurseId === '' ||
                    job?.jobFinalSelectionNurseId === job?.nurse?.uniqueId) &&
                  // moment(job?.startDate).format("MM-DD-YYYY") >= currentDate &&
                  GetDateMergedTime(
                    job?.startDate,
                    job?.startTime
                  ).isSameOrAfter(moment(), 'hh:mm a') && (
                    <IconButton
                      variant={
                        job?.jobFinalSelectionNurseId === job?.nurse?.uniqueId
                          ? 'danger'
                          : 'success'
                      }
                      size="sm"
                      className="me-2"
                      onClick={() =>
                        job?.bidNurseArray?.length === 0
                          ? job?.jobFinalSelectionNurseId ===
                            job?.nurse?.uniqueId
                            ? confirm(
                                'To Release the assigned nurse. Click OK'
                              ).valueOf(true) && webCancel(job?.nurse)
                            : !job?.nurse?.nurseAppAccessControl
                            ? selectNurse(
                                job?.nurse?.id,
                                job?.nurse?.uniqueId,
                                job?.nurse?.nurseType,
                                job?.nurse?.mobileId
                              )
                            : alert(
                                `${job?.nurse?.firstName} ${job?.nurse?.lastName} account is currently Suspended.`
                              )
                          : job?.bidNurseArray
                              ?.filter(
                                v =>
                                  v?.jobBitTableNurseTableId ===
                                  job?.nurse?.uniqueId
                              )
                              .map(
                                value =>
                                  value?.jobBitTableNurseTableId ===
                                    job?.nurse?.uniqueId &&
                                  (job?.jobFinalSelectionNurseId ===
                                  job?.nurse?.uniqueId
                                    ? confirm(
                                        'Are you sure want to cancel?'
                                      ).valueOf(true) &&
                                      webCancelBid(job?.nurse)
                                    : selectNurseBid(
                                        job?.nurse?.uniqueId,
                                        job?.nurse?.mobileId,
                                        value?.bitAmount
                                      ))
                              )
                      }
                    >
                      {job?.jobFinalSelectionNurseId === job?.nurse?.uniqueId
                        ? 'Release'
                        : 'Approve'}
                    </IconButton>
                  )}
                {job?.jobFinalSelectionNurseId !== job?.nurse?.uniqueId &&
                  job?.jobStatus !== 'Unfulfilled' && (
                    <IconButton
                      variant="danger"
                      size="sm"
                      className="me-2"
                      onClick={() => {
                        let name =
                          job?.nurse?.firstName + ' ' + job?.nurse?.lastName;
                        confirm('Are you sure want to Deny?').valueOf(true) &&
                          declinedNurseAction(
                            job?.nurse?.id,
                            job?.nurse?.uniqueId,
                            job?.nurse?.mobileId,
                            job?.nurse?.nurseType,
                            name
                          );
                      }}
                    >
                      Deny
                    </IconButton>
                  )}
              </div>
            </div>
          </div>
        )}
        {job?.customerName && (
          <>
            <Flex className="mt-2">
              <h5 className="fs-9 mb-3">Customer Name</h5>
              {job?.customerVisibility && <p className="text-danger">*</p>}
            </Flex>
            <p>{job?.customerName}</p>
          </>
        )}
        <h5 className="fs-9 mb-3">License Type</h5>
        <Flex>
          {job?.licenseType?.map((item, index) => {
            return (
              <p key={index} className={'me-2'}>
                {item}
              </p>
            );
          })}
        </Flex>
        {job?.specialty && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">Specialty</h5>
              {job?.specialtyRequired && <p className="text-danger">*</p>}
            </Flex>
            <p>{job?.specialty}</p>
          </>
        )}
        {job?.certification?.length !== 0 && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">Certification</h5>
              {job?.certificationRequired && <p className="text-danger">*</p>}
            </Flex>
            <Flex>
              {job?.certification?.map((item, index) => {
                return (
                  <p key={index} className="me-2">
                    {item}
                  </p>
                );
              })}
            </Flex>
          </>
        )}
        {job?.yearOfExperience && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">Experience Level</h5>
              {job?.experienceRequired && <p className="text-danger">*</p>}
            </Flex>
            <p>{job?.yearOfExperience}</p>
          </>
        )}
        {job?.EMRorEHRExperience?.length !== 0 && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">EMR or EHR Experience</h5>
              {job?.emrehrRequired && <p className="text-danger">*</p>}
            </Flex>
            <Flex>
              {job?.EMRorEHRExperience?.map((item, index) => {
                return (
                  <p key={index} className="me-2">
                    {item}
                  </p>
                );
              })}
            </Flex>
          </>
        )}
        <>
          <h5 className="fs-9 mb-3">{job?.jobType} Times</h5>
          <p>{job?.jobTiming}</p>
        </>
        <>
          <h5 className="fs-9 mb-3">Break</h5>
          <p>{job?.break === 'NA' ? 'No Break' : job?.break}</p>
        </>
        <>
          <h5 className="fs-9 mb-3">Current Rate</h5>
          {job?.baseRate == 1 ? <p>No Rate</p> : <p>$ {job?.baseRate} / hr</p>}
        </>
        {job?.enableBid && job?.maxBidAmount && (
          <>
            <h5 className="fs-9 mb-3">Max Bid Amount</h5>
            <p>$ {job?.maxBidAmount} / hr</p>
          </>
        )}
        {job?.notes !== '' && (
          <>
            <h5 className="fs-9 mb-3">Notes</h5>
            <p>{job?.notes}</p>
          </>
        )}

        {Array.isArray(job?.nurseCancelNotes) &&
          job?.nurseCancelNotes?.length !== 0 && (
            <>
              <h5 className="fs-9 mb-3">Nurse cancellation notes</h5>
              {job?.nurseCancelNotes?.map((item, index) => {
                return (
                  <div key={index}>
                    <p>Nurse : {item?.nurseName}</p>
                    {item?.cancelNote && <p>Reason : {item?.cancelNote}</p>}
                  </div>
                );
              })}
            </>
          )}
        {job?.nurseSwapNotes && (
          <>
            <h5 className="fs-9 mb-3 mt-3">Nurse Swap Reason</h5>
            <p>{job?.nurseSwapNotes}</p>
          </>
        )}
        {job?.checkInTime !== '' && (
          <>
            <h5 className="fs-9 mb-3 mt-3">Clock In Details</h5>
            <p>Time = {moment(new Date(job?.checkInTime)).format('hh:mm a')}</p>
            <a
              href={`https://maps.google.com/?q=${job?.checkInFullAddress}`}
              target="_blank"
              rel="noreferrer"
              className="text-primary"
            >
              {job?.checkInFullAddress}
            </a>
          </>
        )}
        {job?.checkOutTime !== '' && (
          <>
            <h5 className="fs-9 mb-3 mt-3">Clock Out Details</h5>
            <p>
              Time = {moment(new Date(job?.checkOutTime)).format('hh:mm a')}
            </p>
            <a
              href={`https://maps.google.com/?q=${job?.checkOutFullAddress}`}
              target="_blank"
              rel="noreferrer"
              className="text-primary"
            >
              {job?.checkOutFullAddress}
            </a>
          </>
        )}

        {job?.pendingOrNoShowFacilityDecideMessage !== '' ? (
          <>
            <h5 className="fs-9 mb-3 mt-3">Reviewer Notes </h5>
            <p>{job?.pendingOrNoShowFacilityDecideMessage}</p>
            {job?.noShowReason !== '' && (
              <>
                <>
                  <h5 className="fs-9 mb-3">
                    Missed {job?.jobType} Reason (Employee)
                  </h5>
                  <p
                    style={{
                      color: '#595959',
                      fontSize: 12,
                      marginTop: 5
                    }}
                  >
                    {job?.noShowReason}
                  </p>
                </>
                {job?.pendingOrNoShowFacilityDecideStatus ? (
                  job?.timeAdjustByFacility ? (
                    <>
                      <h5 className="fs-9 mb-3">Approved Time</h5>
                      <p
                        style={{
                          color: '#595959',
                          fontSize: 12,
                          marginTop: 5
                        }}
                      >
                        Clock In Time -{' '}
                        {job?.checkInTime !== '' &&
                          moment(new Date(job?.checkInTime)).format('h:mma')}
                      </p>
                      <p
                        style={{
                          color: '#595959',
                          fontSize: 12,
                          marginTop: 5
                        }}
                      >
                        Clock Out Time -{' '}
                        {job?.checkOutTime !== '' &&
                          moment(new Date(job?.checkOutTime)).format('h:mma')}
                      </p>
                    </>
                  ) : (
                    <>
                      <h5 className="fs-9 mb-3">Approved Time</h5>
                      <p
                        style={{
                          color: '#595959',
                          fontSize: 12,
                          marginTop: 5
                        }}
                      >
                        Clock In Time -{' '}
                        {moment(new Date(job?.checkInTime)).format('h:mma')}
                      </p>
                      <p
                        style={{
                          color: '#595959',
                          fontSize: 12,
                          marginTop: 5
                        }}
                      >
                        Clock Out Time -{' '}
                        {moment(new Date(job?.checkOutTime)).format('h:mma')}
                      </p>
                    </>
                  )
                ) : (
                  <>
                    <h5 className="fs-9 mb-3">Requested Time</h5>
                    <p
                      style={{
                        color: '#595959',
                        fontSize: 12,
                        marginTop: 5
                      }}
                    >
                      Clock In Time -{' '}
                      {job?.checkInTimeNurse !== '' &&
                        moment(new Date(job?.checkInTimeNurse)).format('h:mma')}
                    </p>
                    <p
                      style={{
                        color: '#595959',
                        fontSize: 12,
                        marginTop: 5
                      }}
                    >
                      Clock Out Time -{' '}
                      {job?.checkOutTimeNurse !== '' &&
                        moment(new Date(job?.checkOutTimeNurse)).format(
                          'h:mma'
                        )}
                    </p>
                  </>
                )}
                {job?.noShowReasonAttachment && (
                  <>
                    <h5 className="fs-9 mb-3">
                      Attachment submitted (Employee)
                    </h5>
                    <IconButton
                      variant="primary"
                      className="me-2"
                      size="sm"
                      onClick={() => {
                        // setDocViewModel({
                        //   view: true,
                        //   name: 'No Show',
                        //   url: job?.noShowReasonAttachment
                        // });
                        window.open(job?.noShowReasonAttachment);
                      }}
                    >
                      Click to download the attachment
                    </IconButton>
                  </>
                )}
                {job?.noShowComments && (
                  <>
                    <h5 className="fs-9 my-3">Notes (Employee)</h5>
                    <p>{job?.noShowComments}</p>
                  </>
                )}
                {job?.noShowManagerReason && (
                  <>
                    <h5 className="fs-9 mb-3">
                      Approved {job?.jobType} Reason (Reviewer)
                    </h5>
                    <p>{job?.noShowManagerReason}</p>
                  </>
                )}
                {job?.noShowManagerReasonAttachment && (
                  <>
                    <h5 className="fs-9 mb-3">
                      Attachment submitted (Reviewer)
                    </h5>
                    <IconButton
                      variant="primary"
                      className="me-2"
                      size="sm"
                      onClick={() => {
                        // setDocViewModel({
                        //   view: true,
                        //   name: 'No Show Manager Attachment',
                        //   url: job?.noShowManagerReasonAttachment
                        // });
                        window.open(job?.noShowManagerReasonAttachment);
                      }}
                    >
                      Click to download the attachment
                    </IconButton>
                  </>
                )}
              </>
            )}
            {job?.neverCheckOutReason !== '' && (
              <>
                <>
                  <h5 className="fs-9 mb-3">
                    Pending Clock Out {job?.jobType} Reason (Employee)
                  </h5>
                  <p
                    style={{
                      color: '#595959',
                      fontSize: 12,
                      marginTop: 5
                    }}
                  >
                    {job?.neverCheckOutReason}
                  </p>
                </>
                {job?.pendingOrNoShowFacilityDecideStatus ? (
                  <>
                    <h5 className="fs-9 mb-3">Time Details</h5>
                    <p
                      style={{
                        color: '#595959',
                        fontSize: 12,
                        marginTop: 5
                      }}
                    >
                      Clock In Time -{' '}
                      {moment(job?.checkInTime).format('hh:mm a')}
                    </p>
                    <p
                      style={{
                        color: '#595959',
                        fontSize: 12,
                        marginTop: 5
                      }}
                    >
                      Clock Out Time -{' '}
                      {moment(job?.checkOutTime).format('hh:mm a')}
                    </p>
                  </>
                ) : job?.timeAdjustByNurse ? (
                  <>
                    <h5 className="fs-9 mb-3">Requested Time Adjustment</h5>
                    <p
                      style={{
                        color: '#595959',
                        fontSize: 12,
                        marginTop: 5
                      }}
                    >
                      Clock In Time -{' '}
                      {job?.checkInTime !== '' &&
                        moment(job?.checkInTime).format('hh:mm a')}
                    </p>
                    <p
                      style={{
                        color: '#595959',
                        fontSize: 12,
                        marginTop: 5
                      }}
                    >
                      Clock Out Time -{' '}
                      {job?.checkOutTimeNurse !== '' &&
                        moment(job?.checkOutTimeNurse).format('hh:mm a')}
                    </p>
                  </>
                ) : (
                  <>
                    <h5 className="fs-9 mb-3">Time Details</h5>
                    <p
                      style={{
                        color: '#595959',
                        fontSize: 12,
                        marginTop: 5
                      }}
                    >
                      Clock In Time -{' '}
                      {moment(job?.checkInTimeNurse).format('hh:mm a')}
                    </p>
                    <p
                      style={{
                        color: '#595959',
                        fontSize: 12,
                        marginTop: 5
                      }}
                    >
                      Clock Out Time -{' '}
                      {moment(job?.checkOutTimeNurse).format('hh:mm a')}
                    </p>
                  </>
                )}
                {job?.neverCheckOutReasonAttachment && (
                  <>
                    <h5 className="fs-9 mb-3">
                      Attachment submitted (Employee)
                    </h5>
                    <IconButton
                      variant="primary"
                      className="me-2"
                      size="sm"
                      onClick={() => {
                        // setDocViewModel({
                        //   view: true,
                        //   name: 'Pending Clock Out',
                        //   url: job?.neverCheckOutReasonAttachment
                        // });
                        window.open(job?.neverCheckOutReasonAttachment);
                      }}
                    >
                      Click to download the attachment
                    </IconButton>
                  </>
                )}
                {job?.neverCheckOutComments && (
                  <>
                    <h5 className="fs-9 my-3">Notes (Employee)</h5>
                    <p>{job?.neverCheckOutComments}</p>
                  </>
                )}
                {job?.neverCheckOutManagerReason && (
                  <>
                    <h5 className="fs-9 mb-3">
                      Approved {job?.jobType} Reason (Reviewer)
                    </h5>
                    <p>{job?.neverCheckOutManagerReason}</p>
                  </>
                )}
                {job?.neverCheckOutManagerReasonAttachment && (
                  <>
                    <h5 className="fs-9 mb-3">
                      Attachment submitted (Reviewer)
                    </h5>
                    <IconButton
                      variant="primary"
                      className="me-2"
                      size="sm"
                      onClick={() => {
                        // setDocViewModel({
                        //   view: true,
                        //   name: 'Pending Clock Out Manager Attachment',
                        //   url: job?.neverCheckOutManagerReasonAttachment
                        // });
                        window.open(job?.neverCheckOutManagerReasonAttachment);
                      }}
                    >
                      Click to download the attachment
                    </IconButton>
                  </>
                )}
              </>
            )}
          </>
        ) : null}

        {job?.pendingOrNoShowFacilityDecideMessage !==
        '' ? null : job?.checkOutMessage !== '' ? (
          <>
            <h5 className="fs-9 mb-3 mt-3">Nurse Clock Out Notes</h5>
            <p
              style={{
                color: '#595959',
                fontSize: 12,
                marginTop: 5
              }}
            >
              {job?.checkOutMessage}
            </p>
          </>
        ) : null}
        {job?.manager_review_comments && (
          <>
            <h5 className="fs-9 mb-3 mt-3">Manager Approval Notes</h5>
            <p>{job?.manager_review_comments}</p>
          </>
        )}
        <>
          <h5 className="fs-9 mb-3 mt-3">Last Updated</h5>
          <p>{moment(job?._lastChangedAt).format('MM-DD-YYYY h:mm a')}</p>
        </>

        {job?.enableBid && (
          <>
            <h5 className="fs-9 mb-3">Bid is Enabled</h5>
            {job?.jobBitFinalAmount !== '' && job?.jobBitFinalAmount !== '' ? (
              <p>Bid Final Amount = $ {job?.jobBitFinalAmount}</p>
            ) : (
              <p>Waiting...</p>
            )}
          </>
        )}

        {/* <h5 className="fs-9 mt-5 mb-2 ">Tags</h5>
        <Link
          to="#!"
          className="badge border link-secondary text-decoration-none me-1"
        >
          Things To Do In Brooklyn, NY
        </Link>
        <Link
          to="#!"
          className="badge border link-secondary text-decoration-none me-1"
        >
          Party
        </Link>
        <Link
          to="#!"
          className="badge border link-secondary text-decoration-none me-1"
        >
          Music
        </Link> */}
        {/* <JobDetailsGmap job={job} /> */}
      </Card.Body>
      <Modal
        show={nurseSwap}
        onHide={() => {
          setJobFinalSelectionNurseId('');
          setNurseSwapReason('');
          setNurseSwap(false);
        }}
        contentClassName="border"
        backdrop="static"
      >
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-body-tertiary px-x1 border-bottom-0"
        >
          <Modal.Title>
            <h5 className="mb-0">Swap Nurse</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-x1 pb-x1 pt-1 fs-10">
          <Form.Group as={Col} md="12" className="mb-2" controlId="reason">
            <Form.Label className="fs-9">Reason</Form.Label>
            <Form.Control
              type="text"
              as="textarea"
              name="reason"
              placeholder={`Swap Reason...`}
              required
              value={nurseSwapReason}
              onChange={e => setNurseSwapReason(e.target.value)}
            />
          </Form.Group>
          <div style={{ marginTop: 10 }}>
            {availableLoading ? (
              <p
                style={{
                  fontSize: 12,
                  color: '#000',
                  textAlign: 'center'
                }}
              >
                Loading...
              </p>
            ) : available?.filter(obj => {
                const jobAcceptedNurses = job?.jobAcceptedNurses;
                const isMatched = jobAcceptedNurses?.some(
                  item => item === obj?.id?.uniqueId
                );
                return obj?.id.availableTime && !isMatched;
              }).length === 0 ? (
              <p
                style={{
                  fontSize: 12,
                  color: '#000',
                  textAlign: 'center'
                }}
              >
                No nurse is available.
              </p>
            ) : (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Control
                  type="text"
                  name="reason"
                  placeholder={`Search nurse name.`}
                  required
                  value={searchSwapNurse}
                  onChange={e => setSearchSwapNurse(e.target.value)}
                />
                {filterSwapNurse(available)
                  ?.filter(obj => {
                    const jobAcceptedNurses = job?.jobAcceptedNurses;
                    const isMatched = jobAcceptedNurses?.some(
                      item => item === obj?.id?.uniqueId
                    );
                    return obj?.id.availableTime && !isMatched;
                  })
                  .map((item, index) => {
                    return (
                      <UserJobCard
                        key={index}
                        element={item}
                        jobFinalSelectionNurseId={jobFinalSelectionNurseId}
                        setJobFinalSelectionNurseId={
                          setJobFinalSelectionNurseId
                        }
                      />
                    );
                  })}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              setJobFinalSelectionNurseId('');
              setNurseSwapReason('');
              setNurseSwap(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              !loading && swapOldNurse !== undefined && swapNurse();
            }}
          >
            {loading ? 'Loading...' : 'Submit'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={removeNurse}
        onHide={() => setRemoveNurse(false)}
        contentClassName="border"
        centered
        backdrop="static"
      >
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-body-tertiary px-x1 border-bottom-0"
        >
          <Modal.Title>
            <h5 className="mb-0">Remove Nurse</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-x1 pb-x1 pt-1 fs-10">
          <Form.Group as={Col} md="12" className="mb-2" controlId="reason">
            <Form.Label className="fs-9">Reason</Form.Label>
            <Form.Control
              type="text"
              as="textarea"
              name="reason"
              placeholder={`Reason...`}
              required
              value={removeNurseReason}
              onChange={e => setRemoveNurseReason(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              {
                setRemoveNurseReason('');
                setRemoveNurse(false);
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              !loading && cancelNurse();
            }}
          >
            {loading ? 'Loading...' : 'Submit'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={removeNurseBid}
        onHide={() => setRemoveNurseBid(false)}
        contentClassName="border"
        centered
        backdrop="static"
      >
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-body-tertiary px-x1 border-bottom-0"
        >
          <Modal.Title>
            <h5 className="mb-0">Remove Nurse</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-x1 pb-x1 pt-1 fs-10">
          <Form.Group as={Col} md="12" className="mb-2" controlId="reason">
            <Form.Label className="fs-9">Reason</Form.Label>
            <Form.Control
              type="text"
              as="textarea"
              name="reason"
              placeholder={`Reason...`}
              required
              value={removeNurseReason}
              onChange={e => setRemoveNurseReason(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              {
                setRemoveNurseReason('');
                setRemoveNurseBid(false);
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              !loading && cancelNurseBid();
            }}
          >
            {loading ? 'Loading...' : 'Submit'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={docViewModel.view}
        onHide={() => {
          setDocViewModel({
            view: false,
            name: '',
            url: ''
          });
        }}
        contentClassName="border"
        centered
      >
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-body-tertiary px-x1 border-bottom-0"
        >
          <Modal.Title>
            <h5 className="mb-0">{docViewModel.name}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-x1 pb-x1 pt-1 fs-10">
          <iframe
            title="My Website"
            src={`https://docs.google.com/gview?url=${docViewModel.url}&embedded=true`}
            style={{ width: '100%', height: '100vh', border: 'none' }}
          />
        </Modal.Body>
        <Modal.Footer className="bg-body-tertiary px-x1 border-top-0">
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              setDocViewModel({
                view: false,
                name: '',
                url: ''
              });
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

JobDetailContent.propTypes = {
  job: PropTypes.any,
  nurses: PropTypes.any,
  getJobDetail: PropTypes.any
};

export default JobDetailContent;
